<ng-template #confirmLogout>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close close pull-right"
      i18n-aria-label="@@globalCloseAria"
      aria-label="Close"
      (click)="modalRef?.hide();"
    >
      <span
        aria-hidden="true"
        class="visually-hidden"
      >&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <span i18n="@@headerLogoutConfirmText">
      Bist du dir sicher, dass du alle Beobachtenden und Teilnehmenden ausloggen willst? Nicht gespeicherte Daten gehen
      verloren!
    </span>
    <div class="text-center my-3">
      <div
        class="btn btn-primary m-2"
        (click)="modalRef?.hide();"
        i18n="@@headerLogoutNo"
      >Nein</div>
      <div
        class="btn btn-danger m-2"
        (click)="moderatorForceLogout(); this.modalRef.hide()"
        i18n="@@headerLogoutYes"
      >Ja</div>
    </div>
  </div>
</ng-template>

@if (!socketService.connected) {
<div
  class="row "
  style="position: absolute;
            z-index: 9999;
            margin: 0px auto;
            width: 100%;
            pointer-events: none;"
>
  <div class="col text-center p-5 mt-3">
    <span
      class="alert alert-danger p-5"
      i18n="@@headerConnectionLost"
    >Ihre Internetverbindung ist möglicherweise getrennt worden</span>
  </div>
</div>
}
<nav
  #header
  id="headernavbar"
  class="header navbar navbar-expand justify-content-between navbar-light py-0 border-bottom"
  style=" background-color: #fff;"
>
  <div>
    @if (brand || brandlink) {
    <a
      class="navbar-brand"
      href="{{brandlink}}"
    >
      {{brand}}
    </a>
    } @else {
    <img
      class="
  navbar-prm-logo"
      alt="Mercer PRM"
      src="assets/MercerPrm.png"
    >
    }
  </div>

  <div class="header-menu">
    <ul class="navbar-nav">
      @for (item of menuItems; track item) {
      @if (!((item.routerLink == 'conference' && pack.disableReportView) || (item.routerLink == 'preptimes' &&
      $any(pack.me).role != 'moderator') || (item.routerLink == 'videoupload' && !pack.participantVideoByModerator))) {
      <li
        class="nav-item p-4"
        [routerLink]="item.routerLink"
        [routerLinkActiveOptions]="{exact:false}"
        [appLayout]="layoutService.activeColor"
        routerLinkActive="active"
        style="cursor: pointer"
      >
        <i class="{{item.text}} pr-2"></i>
        <br>
        <span
          i18n="@@headerNavItemLabel"
          class="nav-item-label"
        >{{item.label}}</span>
      </li>
      }
      }
    </ul>
  </div>
  @if (router.url.includes('participant')) {
  <div>
    @for (entry of urlStringToEndTime | keyvalue; track entry) {
    <app-preptime-countdown
      (done)="preparePrepTimes()"
      [endTime]="entry.value.endtime"
      [url]="entry.key"
      [emitDone]="prepTimeDone"
    >
    </app-preptime-countdown>
    }
  </div>
  }
  @if (isModerator) {
  <div>
    @if (this.pack.accessValidation == 'liveauth' && this.pack.enableModeratorChangeAccessValidation) {
    <div
      class="btn btn-outline-danger d-inline-flex align-items-center"
      (click)="changeAuthAccess('disabled')"
      tooltip="Login gesperrt"
      i18n-tooltip="@@headerLoginLockedTooltip"
    >
      <i class="ri-lock-line"></i>
    </div>
    }
    @if (this.pack.accessValidation == 'disabled' && this.pack.enableModeratorChangeAccessValidation) {
    <div
      class="btn btn-outline-success d-inline-flex align-items-center"
      (click)="changeAuthAccess('liveauth')"
      tooltip="Login freigegeben"
      i18n-tooltip="@@headerLoginUnlockedTooltip"
    >
      <i class="ri-lock-unlock-line"></i>
    </div>
    }
  </div>
  }
  <div class="header-user">
    <table>
      <tr>
        <td class="text-right pr-2 user-info">
          <b
            class="name-display"
            [title]="myUser.firstname + ' ' + myUser.lastname"
          >
            <span>{{myUser.firstname}}</span>
            <span>{{myUser.lastname}}</span>
          </b>
          <span class="small date-display">{{currentDate}}</span>
        </td>
        <td>
          <app-user-image-and-name-display
            [showName]=false
            [participant]="myUser"
          ></app-user-image-and-name-display>
        </td>
        <td>
          <div class="btn-group">
            <i
              class="ri-arrow-down-s-line "
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style="cursor: pointer"
            ></i>
            <div class="dropdown-menu dropdown-menu-right">
              <h6 class="dropdown-header dropdown-user-name">{{myUser.firstname}} {{myUser.lastname}}</h6>
              <a
                i18n="@@headerLogout"
                class="dropdown-item text-danger"
                href="#"
                (click)="logout()"
              >Abmelden</a>
              @if (this.isModerator) {
              <a
                class="dropdown-item text-danger"
                i18n="@@headerLogoutAll"
                (click)="this.modalRef = this.modalService.show(confirmLogout)"
              >
                Abmelden (Beos + TN)
              </a>
              }
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</nav>

<app-timezone-modal></app-timezone-modal>